"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteStation = exports.updateStation = exports.addStation = exports.fetchStationsIfNeeded = exports.DELETE_STATION = exports.UPDATE_STATION = exports.ADD_STATION = exports.FETCH_STATIONS = void 0;
var utils_1 = require("../../utils");
exports.FETCH_STATIONS = (0, utils_1.networkActionTypes)("FETCH_STATIONS");
exports.ADD_STATION = (0, utils_1.networkActionTypes)("ADD_STATION");
exports.UPDATE_STATION = (0, utils_1.networkActionTypes)("UPDATE_STATION");
exports.DELETE_STATION = (0, utils_1.networkActionTypes)("DELETE_STATION");
var fetchStations = (0, utils_1.networkAction)(exports.FETCH_STATIONS, "/stations");
exports.fetchStationsIfNeeded = (0, utils_1.makeIfNeededAction)(fetchStations, "stations");
var _check = function (state) { return !(state.stations.isFetching ||
    state.stations.isAdding ||
    state.stations.isUpdating ||
    state.stations.isDeleting); };
var _addStation = (0, utils_1.networkAction)(exports.ADD_STATION, "/stations", "POST");
var addStation = function (body, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch(_addStation(body, {}, accessToken));
    };
};
exports.addStation = addStation;
var updateStation = function (stationID, stationData, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch((0, utils_1.networkAction)(exports.UPDATE_STATION, "/stations/".concat(stationID), "PUT")(stationData, {}, accessToken));
    };
};
exports.updateStation = updateStation;
var deleteStation = function (stationID, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch((0, utils_1.networkAction)(exports.DELETE_STATION, "/stations/".concat(stationID), "DELETE")({}, { id: stationID }, accessToken));
    };
};
exports.deleteStation = deleteStation;
